import React, { FC, PropsWithChildren } from 'react';
import { ReactNotifications } from 'react-notifications-component';

import './style.css';

import { Header, Footer } from '../../components';

const AppLayout: FC<PropsWithChildren> = props => {
  return (
    <>
      <ReactNotifications className="notificator" />
      <Header />
      <main className="container main-container">{props.children}</main>
      <Footer />
    </>
  );
};

export default AppLayout;
